import { useQuery } from "@tanstack/react-query";

import { Response } from "../types";

import { DatasetGroupWrite, DatasetGroupRead } from "@/types/dataset-groups";
import { ENDPOINTS } from "@/api/application-api";
import { authHeader } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";

export const useDatasetGroup = (userToken: string, datasetGroupId: string) =>
  useQuery<Response<DatasetGroupRead & DatasetGroupWrite, "dataset_group", string>>(
    [ENDPOINTS.dataset_groups, datasetGroupId],
    () =>
      fetch(`${ENDPOINTS.dataset_groups}/${datasetGroupId}`, {
        headers: authHeader(userToken),
      }).then(handleResponse),
  );
